import _ from "lodash";
import PropTypes from "prop-types";
import Tabs from "./Tabs";
import { Box, Divider } from "@mui/material";
import Button from "../toolkit/ButtonV1";
import { useEffect, useState } from "react";
import LoadingSpinner from "../toolkit/LoadingSpinner";
import ErrorAlert from "../toolkit/ErrorAlert";
import FormControl from "./FormControl";
import "../styles/FiltersTemplate.css";

export default function FiltersTemplate({
  isLoading,
  error,
  tabs,
  filterChangeHandler,
  filterObj = {},
  AdditionalList,
  BuSites,
  CloseFilter,
  activeTab = 0,
  ID
}) {
  const [active, setActive] = useState();
  const [activeTabTrgive, setActiveTabTrg] = useState(false);
  const [selections, setSelections] = useState(filterObj);
  const params = new URLSearchParams(window.location.search);

  const StatusID = params.get("status");
  useEffect(() => {
    setSelections(filterObj);
  }, [filterObj]);

  useEffect(() => {
    if (ID == 1) {
      setActive(tabs[1]);
    } else if (activeTabTrgive == true) {  //When clear filters that time filters tab move to first tab
      setActive(tabs[0]);
      //setActiveTabTrg(false);
    } else {
      setActive(tabs[activeTab]);
    }
  }, [tabs]);

  function onTabChange(tabId) {
    setActive(tabs.find((tab) => tab.id === tabId));
  }

  function handleChange(field, data) {
    const newSelections = _.cloneDeep(selections);
    if (field == "countryName") {
      AdditionalList(data);
    }
    if (field == "site") {
      BuSites(data);
    }
    setSelections({ ...newSelections, [field]: data });
  }

  function resetSelections() {
    setActiveTabTrg(true)
    setSelections({});
    AdditionalList(null);
    BuSites(null);
    //filterChangeHandler({});
    filterChangeHandler({
      pageNumber: 1,
      subSite: "",
      vendorCityName: "",
      countryName: "",
      vendorStateName: "",
      biddingIds: "",
      statusIds: "",
      proficiencyIds: "",
      vendorName: "",
      period: "",
      sortType: "",
      clientTemplateId: "",
      site: "",
      claycoBiddingIds: "",
      productCategoryIds: "",
      geographicAreas: "",
      clientVendorRefId: "",
      firstLetter: "",
      searchType: ""
    });
  }

  return (
    <Box className="filters-container">
      {isLoading ? (
        <LoadingSpinner />
      ) : error ? (
        <ErrorAlert message={error} />
      ) : (
        <Box>
          <Box>
            {tabs.length > 1 ? (
              <Tabs
                variant="box"
                tabs={tabs.map(({ filters, ...tab }) => tab)}
                selected={active?.id}
                onChange={onTabChange}
              />
            ) : (
              <></>
            )}
            <Divider />

            {active?.fields?.filter(r => !r.hidden).map((field) => (
              <Box key={field.id}>
                <FormControl
                  fieldId={field.id}
                  required={field.required}
                  label={field.label}
                  inputType={field.inputType}
                  multiple={field.multiple}
                  items={field.options}
                  value={field.id === "statusIds" && StatusID == "true" ? (selections[field.id] || [16]) : (selections[field.id] || "")} // abdul change for client review navigation
                  handleChange={(value) => handleChange(field.id, value)}
                  width={field.width || "100%"}
                  disabled={field.disabled}
                  heighlight={"false"}
                />
              </Box>
            ))}

          </Box>
          <Box sx={{ flexGrow: 1, display: "flex" }} />
          <Divider />
          <Box className="footer">
            <Button
              size="small"
              label="Clear Filters"
              role="secondary"
              onClick={() => {
                resetSelections()
                CloseFilter(false);
                AdditionalList(null);
                BuSites(null);
              }}
            />
            <Button
              size="small"
              label="Save Filters"
              onClick={() => {
                CloseFilter(true);
                filterChangeHandler(selections)
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}

FiltersTemplate.propTypes = {
  /**
   * The tab items to show at the top
   */
  tabs: PropTypes.array,
  /**
   * Object to store user selections/inputs
   */
  filterObj: PropTypes.object,
  /**
   * Handler to call when a filter has changed value
   */
  filterChangeHandler: PropTypes.func,
};

FiltersTemplate.defaultProps = {
  tabs: [],
  filterObj: {},
  filterChangeHandler: (args) => console.log(args),
};
